<template>
  <div id="app">
    <router-view></router-view>
    <share-poster ref="poster" :type="2"></share-poster>
  </div>
</template>
<script>
import SharePoster from '@/summerCamp/components/sharePoster'
import Bus from './utils/bus'
export default {
  name: 'App',
  components: {
    SharePoster
  },
  mounted() {
    // 在这设置app的 setAppTitleBar 路由跳转后不生效
    Bus.$on('share', () => {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 16,
          action: 'click',
          elemname: '分享主会场'
        }
      })
      this.$refs.poster.show()
    })
  }
}
</script>

<style>
#app {
  font-family: 'PingFangSC-Regular', 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-touch-callout: none !important;

  /* background: #f8d484; */

  /* background-image: linear-gradient(#9fe0c2, #f8d484); */
}

img {
  width: 100%;
}
</style>
